import { FetchClient } from "@/core/client/fetch_client"
import { StatusCode } from "@/core/generated/api/enums/status_code"
import { ResponseModel } from "@/core/generated/api/models/response_model"
import { ResponseSerializer } from "@/core/generated/api/response_serializer"
import { AUTH_KEY, getItem } from "@/utils/browserStorage"
import { getService } from "hooks/useStartup"
import { useEffect, useState } from "react"
import { Space } from "../models/space"

export const useSpaceByToken = () => {
  const spaceToken: string = getItem(AUTH_KEY)
  const [data, setData] = useState<Space | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [code, setCode] = useState<number>(StatusCode.Ok)
  const [message, setMessage] = useState<string>("")

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      let response: ResponseModel | null = null

      try {
        const client: FetchClient = getService(FetchClient)
        response = await client.getAsync("/v1/spaces/me")
        if (response !== null) {
          const model: Space | null =
            ResponseSerializer.deserialize<Space>(response)
          if (model !== null) {
            setData(model)
            setCode(response.code)
          } else {
            setCode(StatusCode.NoContent)
          }
        } else {
          setCode(StatusCode.BadRequest)
        }
      } catch (err) {
        console.error(err)
        setCode(StatusCode.BadRequest)
      } finally {
        setMessage(response?.message)
        setLoading(false)
      }
    }

    getData()
  }, [spaceToken])

  return { data, loading, code, message }
}
